import Flickity from 'flickity';
import { DeviceUtils } from '@streamamg/amg-common';

export class FlickityUtils {
  public static stopSlideOnItemClick(
    flickity: Flickity,
    carouselElement: HTMLElement,
    containerId: string,
    carouselClickElement: string
  ): void {
    const isIOSDevice = DeviceUtils.isIOSDevice(window.navigator);

    flickity
      .on('dragStart', () => {
        // fix IOS bug
        if (isIOSDevice) {
          window.document.getElementById(containerId).ontouchmove = e => e.preventDefault();
        }

        // fix click slide on drag
        Array.from(carouselElement.querySelectorAll(carouselClickElement)).forEach(
            (el) => {
              (el as HTMLElement).style.pointerEvents = 'none';
            },
        );
      });
    flickity.on('dragEnd', () => {
      if (isIOSDevice) {
        window.document.getElementById(containerId).ontouchmove = () => true;
      }

      Array.from(carouselElement.querySelectorAll(carouselClickElement)).forEach(
          (el) => {
            (el as HTMLElement).style.pointerEvents = 'all';
          },
      );
    });
  }
}
